import styled from 'styled-components';
import { Avatar } from 'antd';
import { Input, Mentions } from 'antd';



const Chat = styled.div`
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const OneLinerContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const ChatContainer = styled.div`
  position: relative;
  display: flex;
  gap: 12px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const ChatInput = styled(Input)`
  flex: 1;
  resize: none !important;
  height: 40px !important;
  overflow: hidden !important;
  align-items: center !important;

  & :focus {
    border: none;
    outline: none;
  }
`;

const ChatInput3 = styled(Mentions)`
  .ant-mentions-measure > div[contenteditable="false"],
  textarea > div[contenteditable="false"] {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background-color: #e6f4ff;
    border-radius: 4px;
    padding: 2px 6px;
    margin: 0 2px;
    color: #1890ff;
    font-weight: 500;
    line-height: 1.2;
    vertical-align: middle;
  }

  .selected-mention {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background-color: #e6f4ff;
    border-radius: 4px;
    padding: 0 4px;
    margin: 0 2px;
    color: #1890ff;
    font-weight: 500;

    .mention-avatar {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  flex: 1;
  resize: none !important;
  height: 40px !important;
  overflow: hidden !important;
  align-items: center !important;

  & :focus {
    border: none;
    outline: none;
  }
  
  textarea {
    flex: 1;
  resize: none !important;
  height: 40px !important;
  overflow: hidden !important;
  align-items: center !important;

  & :focus {
    border: none;
    outline: none;
  }
  }
`

const ChatActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding-top: 10px;
  background: #fff;
`;

export const MentionOption = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SelectedMention = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: #e6f4ff;
  border-radius: 4px;
  padding: 0 4px;
  margin: 0 2px;
  color: #1890ff;
  font-weight: 500;
`;

export const MentionAvatar = styled(Avatar)`
  background-color: #1890ff;
  font-size: 12px;
`;

export default {
  ChatContainer,
  ChatInput,
  ChatInput3,
  ChatActionsContainer,
  OneLinerContainer,
  Chat,
};
